<template>
  <div id="messageSetting" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>业务设置</el-breadcrumb-item>
      <el-breadcrumb-item>消息设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="业务对象" :label-width="formLabelWidth">
            <el-select v-model="businessobject" placeholder="请选择" size="small" clearable>
              <el-option label="报表消息" value="报表消息"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" :label-width="formLabelWidth" clearable>
            <el-date-picker
              v-model="searchformDate"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              range-separator="~"
              :picker-options="pickerOptions"
              size="small"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="page">
      <el-row>
        <el-col :span="24">
          <el-button @click="batchOutage" type="primary" size="small" style="margin-bottom: 8px;">添加消息</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" style="width: 100%;margin-top: 5px;" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @row-click="clickDrawer">
        <el-table-column label="ID" width="120">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="title">
        </el-table-column>
        <el-table-column label="业务对象" prop="businessobject">
        </el-table-column>
        <el-table-column label="发送条件" prop="reportname">
        </el-table-column>
        <el-table-column label="发送时间">
          <template slot-scope="scope">
            <div v-if="scope.row.cyclesend">
              {{scope.row.cyclesend}},{{scope.row.cycletime}}
            </div>
            <div v-else>
              {{scope.row.sendcreatetime}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="接收人员" prop="receivePersonnel">
        </el-table-column>
        <el-table-column label="发送渠道" prop="sendChannel">
        </el-table-column>
        <el-table-column label="通知内容">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="examine(scope.row.noticeContent)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime">
        </el-table-column>
        <el-table-column label="开关" prop="status">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.status === 1 ? true : false"
              @change="(val) => onStatusChange(val, scope.row.id,1)"
              active-color="#408ae7"
              inactive-color="#d9d9d9"
              active-text="开"
              inactive-text="关"
              @click.stop.native>
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="batchOutage(scope.row)">编辑</el-button>
            <el-button type="text" @click.stop="deletClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
    <!-- 查看 -->
    <el-dialog
      title="查看内容"
      :visible.sync="examineShow"
      width="480px" style="margin-top: 10%;" id="dialog">
      <div style="width: 100%;text-aligm: center;height: 360px;overflow: auto;">
        {{examineContont}}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="examineShow = false" size="small" type="TheCustom">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="360px" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
          <div>
            <div style="font-size: 16px;">
              你确认要删除该信息吗？
            </div>
            <div style="font-size: 14px;">删除后
              <span style="color: #e90e24;font-size: 14px;">
                消息配置将无法找回
              </span>
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteChange()" size="small" :loading="deleteLoading">确 定</el-button>
        <el-button @click="deleteShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 抽屉 -->
    <el-drawer
      :with-header="false"
      title="111"
      :visible.sync="buyDrawer"
      size="840px">
      <div style="padding: 20px;background-color: white;">
        <el-row>
          <el-col :span="12" style="font-size: 16px;font-weight: 600;">
            违规周报消息发送
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-switch
              :value="drawerData.status === 1 ? true : false"
              @change="(val) => onStatusChange(val, drawerData.id,2)"
              active-color="#408ae7"
              inactive-color="#d9d9d9"
              active-text="开"
              inactive-text="关"
              @click.stop.native>
            </el-switch>
            <i class="el-icon-close" style="font-size: 19px;font-weight: 400;cursor: pointer;margin-left: 60px;" @click="buyDrawer = false">
            </i>
          </el-col>
          <el-col :span="24" style="text-align: left;margin-top: 20px;">
            业务对象：{{drawerData.businessobject}}
          </el-col>
          <el-col :span="24" style="text-align: left;margin: 16px 0;">
            发送条件：{{drawerData.reportname}}
          </el-col>
          <el-col :span="24" style="text-align: left;">
            发送时间：{{drawerData.sendcreatetime}}
          </el-col>
        </el-row>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 20px 20px 0 20px;font-size: 30px;">
        <el-tab-pane label="基本消息" name="first"></el-tab-pane>
        <el-tab-pane label="消息日志" name="second"></el-tab-pane>
      </el-tabs>
      <el-card class="margin_bottom20 no_margin" style="margin: 20px;">
        <el-form label-width="120px" v-if="activeName == 'first'">
          <el-form-item label="标题：">
            {{drawerData.title}}
          </el-form-item>
          <el-form-item label="发送渠道：">
            {{drawerData.sendChannel}}
          </el-form-item>
          <el-form-item label="微信名称：" v-if="drawerData.wechatuser">
            {{drawerData.wechatuser}}
          </el-form-item>
          <el-form-item label="微信群：" v-if="drawerData.wechatGroup">
            {{drawerData.wechatGroup}}
          </el-form-item>
          <el-form-item label="企业微信名称：" v-if="drawerData.enterpriseWechatuser">
            {{drawerData.enterpriseWechatuser}}
          </el-form-item>
          <el-form-item label="企业微信群：" v-if="drawerData.enterpriseWechatGroup">
            {{drawerData.enterpriseWechatGroup}}
          </el-form-item>
          <el-form-item label="邮箱：" v-if="drawerData.emailname">
            {{drawerData.emailname}}
          </el-form-item>
          <el-form-item label="钉钉名称：" v-if="drawerData.dingtalkuser">
            {{drawerData.dingtalkuser}}
          </el-form-item>
          <el-form-item label="钉钉群：" v-if="drawerData.dingtalkGroup">
            {{drawerData.dingtalkGroup}}
          </el-form-item>
          <el-form-item label="创建时间：" v-if="drawerData.createTime">
            {{drawerData.createTime}}
          </el-form-item>
          <el-form-item label="通知内容：" v-if="drawerData.noticeContent">
            {{drawerData.noticeContent}}
          </el-form-item>
        </el-form>
        <div v-else>
          <el-table :data="tableData2" style="width: 100%;margin-top: 5px;" v-loading="tableLoading2" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-table-column label="发送时间" prop="sendcreatetime">
            </el-table-column>
            <el-table-column label="报表名称" prop="reportname">
            </el-table-column>
            <el-table-column label="发送渠道" prop="sendChannel">
            </el-table-column>
            <el-table-column label="接收人员" prop="receivePersonnel">
            </el-table-column>
            <el-table-column label="发送状态">
              <template slot-scope="scope">
                <div v-if="scope.row.statusType == 1">
                  <el-button type="success" size="mini">已发送</el-button>
                </div>
                <div v-else>
                  <el-button type="danger" size="mini">未发送</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div v-show="this.tableData2.length > 0">
            <pagination
              :currentPage="currentPage2" :pageSizes="[10, 20, 50, 100]"
              :total="totalNum2" @handleSizeChange="handleSizeChange2" @handleCurrentChange="handleCurrentChange2">
            </pagination>
          </div>
        </div>
      </el-card>
    </el-drawer>

  </div>

</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        activeName: 'first',
        examineContont: '',
        examineShow: false,
        deleteShow: false,
        deleteLoading: false,
        tableLoading: false,
        tableLoading2: false,
        buyDrawer: false,
        formLabelWidth: '100px',
        tableData: [],
        searchformDate: [],//时间
        businessobject: '',
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        totalNum: 10,
        tableData2: [],
        pageNo2: 1,
        pageSize2: 10,
        currentPage2: 1,
        totalNum2: 10,
        drawerData: {},
        rowId: '',
        bmcid: '',
        pickerOptions: {
  				shortcuts: [{
            text: '今日',
            onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
          },{
            text: '近7日',
            onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
          }, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}]
  			},
      }
    },
    mounted() {
      this.getBmcListByKefuid()
    },
    components: {
      pagination
    },
    methods: {
      getBmcListByKefuid(){
        fetch({
          url: "hcm/userin/getBmcListByKefuid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then((res)=>{
          let result=JSON.parse(res)
          if(result.status=='10000'){
            for(let item of result.data){
              if(item.checked=='true'){
                this.bmcid=Number(item.bmcid)
                localStorage.setItem('bmcKefuid',this.Kefuid);
                localStorage.setItem('bmcKefuName',item.company_memoname);
              }
            }
            this.oneStep()
          }
        })
      },
      // 开关
      onStatusChange(val,id,type) {
        let status
        if (val) {
          status = 1
        } else {
          status = 0
        }
        let data = {
          id: id,
          status: status
        }
        fetch({
          url: '/report/report/messagesetting',
          method: 'put',
          data: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
          },
          noFormat: false,
          responseType: "json"
        }).then(result => {
          let res = result;
          if (res.code == '200') {
            if (type == 1) {
              this.oneStep()
            } else {
              this.getOrderdetails(this.rowId)
            }
          } else {
            this.$message.error('接口报错');
          }
        });
      },
      handleClick() {
        if (this.activeName === 'second') {
          this.oneStep2()
        }
      },
      // 开启抽屉
      clickDrawer(row) {
        this.getOrderdetails(row.id)
        this.rowId = row.id
        this.activeName = 'first'
      },
      getOrderdetails(id) {
        let url = '/report/report/messagesetting/' + id
        fetch({
          url: url,
          method: 'get',
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          if (res.code == '200') {
            this.buyDrawer = true
            this.drawerData = res.data
          } else {
             this.$message.error('接口报错');
          }
        });
      },
      // 查看
      examine(data) {
        this.examineShow = true
        this.examineContont = data
      },
      // 删除打开
      deletClick(data) {
        this.deleteShow = true
        this.id = data.id
      },
      // 删除
      deleteChange() {
        this.deleteLoading = true
        let data = {
          ids: this.id
        }
        let url = '/report/report/messagesetting/' + this.id
        fetch({
  				url: url,
  				method: 'DELETE',
  				// data: JSON.stringify(data),
  				headers: {
  					'Content-Type': 'application/json',
  				},
  				noFormat: false,
  				responseType: "json"
        }).then(result => {
          let res = result;
          if (res.code == '200') {
            this.deleteShow = false
            this.deleteLoading = false
            this.oneStep()
          } else {
             this.$message.error('接口报错');
          }
        });
      },
      // 时间赋值
      getRecentDate(picker,n){
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
        if(picker){
          picker.$emit('pick', [start, end]);
        }
        if (n === 1) {
          this.searchformDate[0] = end;
          this.searchformDate[1] = end;
        } else {
          this.searchformDate[0] = start;
          this.searchformDate[1] = end;
        }
      },
      // 数据源
      oneStep() {
        this.tableLoading = true
        let params = {
          pageNum: this.pageNo,
          pageSize: this.pageSize,
          bmcid: this.bmcid
        }
        if (this.searchformDate) {
          if (this.searchformDate[0] && this.searchformDate[1]) {
            params['params[beginTime]'] = this.$options.filters["fullTime"](
              this.searchformDate[0]
            ).substring(0, 10) + " 00:00:00";
            params['params[endTime]'] = this.$options.filters["fullTime"](
              this.searchformDate[1]
            ).substring(0, 10) + " 23:59:59";
          }
        }
        if (this.businessobject) {
          params.businessobject = this.businessobject
        }
        fetch({
          url: "/report/report/messagesetting/list",
          method: "get",
          params:params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          if (res.code == '200') {
            this.tableData = res.rows
            this.totalNum = res.total
            this.tableLoading = false
          } else {
             this.$message.error('接口报错');
             this.tableLoading = false
          }
        });
      },
      // 数据源
      oneStep2() {
        this.tableLoading2 = true
        let params = {
          pageNum: this.pageNo2,
          pageSize: this.pageSize2,
          messageid: this.rowId,
        }
        fetch({
          url: "/report/report/messagelog/list",
          method: "get",
          params:params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          if (res.code == '200') {
            this.tableData2 = res.rows
            this.totalNum2 = res.total
            this.tableLoading2 = false
          } else {
             this.$message.error('接口报错');
             this.tableLoading2 = false
          }
        });
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.oneStep();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.oneStep();
      },
      handleSizeChange2(val) {
        this.pageSize2 = `${val}`
        this.oneStep2();
      },
      handleCurrentChange2(val) {
        this.pageNo2 = `${val}`
        this.oneStep2();
      },
      // 跳转
      batchOutage(item) {
        if (item) {
          this.$router.push({
            path: '/addMessage',
            query: { id: item.id }
          })
        } else {
          this.$router.push('/addMessage')
        }
      },
    },
  }
</script>
<style lang="scss">
#messageSetting {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-drawer {
    background-color: rgba(240, 242, 245, 1) !important;
  }
  .el-drawer .el-drawer__body {
    padding: 0;
  }
  .page {
    margin: 20px 20px 10px 20px;
    background-color: white;
  }
}

</style>
